"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _highlight = _interopRequireDefault(require("highlight.js"));

var _BareHighlight = _interopRequireDefault(require("./BareHighlight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var Highlight = function Highlight(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, ["children"]);

  return _react.default.createElement(_BareHighlight.default, Object.assign({}, rest, {
    highlightjs: _highlight.default
  }), children);
};

Highlight.defaultProps = {
  className: '',
  languages: [],
  worker: null
};
process.env.NODE_ENV !== "production" ? Highlight.propTypes = {
  children: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  languages: _propTypes.default.arrayOf(_propTypes.default.string),
  worker: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

} : void 0;
var _default = Highlight;
exports.default = _default;